
import { Component, Vue } from 'vue-property-decorator';
import MyCompanyAppusersIndex from '@/pages/mycompany/appusers/Index.vue';
@Component({
  components: { MyCompanyAppusersIndex }
})
export default class AppUsersIndex extends Vue {}
